export const noDuplicatesValidatorFactory =
  <T>(isEqual: (a: T, b: T) => boolean) =>
  () => ({
    validator: (rule: unknown, value: T[]) =>
      new Promise((resolve, reject) => {
        if (value.reduce((prev, curr) => prev && value.filter((x) => isEqual(x, curr)).length < 2, true)) {
          return resolve('');
        }

        return reject('No duplicates allowed');
      }),
  });
